// External libraries
import React from 'react';
import { LoadingElement } from '@/components/Common';
import { css } from '@emotion/core';

// Internal modules
import { features } from '@/lib';

const CardIconsBarLoadingElement = () => {
  const { allowedBankTypes } = features.config;
  const height = allowedBankTypes.length ? '87' : '36';

  return (
    <LoadingElement
      height={`${height}px`}
      styleOverrides={css({ marginBottom: '12px' })}
      viewBoxHeight={height}
    />
  );
};

export { CardIconsBarLoadingElement };
